import { render, staticRenderFns } from "./EndorsementsDataItemArray.vue?vue&type=template&id=38616671"
import script from "./EndorsementsDataItemArray.vue?vue&type=script&lang=js"
export * from "./EndorsementsDataItemArray.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports